<app-header [item]="idComercio" (ecomerce)="validarecomerce( $event )"></app-header>
<app-loaing *ngIf="loading"></app-loaing>
<div class="row cards-font" *ngIf="flagTx && !loading">
    <div class="col-3" style="padding: 0px 10px;"></div>
    <div class="col-6" style="padding: 0px 10px;">
        <div id="card" class="card text-dark bg-light  mb-2">
            <div class="row card-headerI">
                <div class="col-3" style="padding: 0px 3px;">
                    <div class="circulob" style=" width: 40px; height: 40px;">
                        <img [src]="nuevasTiendas.tipo_negocio.icono" style=" width: 40px; height: 40px;" alt="">
                    </div>
                </div>
                <div class="col-9" style="padding: 0px 3px;">
                    <b style="margin: 0px;">{{nuevasTiendas.nombre}}</b>
                </div>
            </div>
            <div class="card-bodyI">
                <p style="font-size: 7pt;">{{nuevasTiendas.tipo_negocio.nombre}}</p>
                <p>{{nuevasTiendas.direccion}}</p>
                <p style="padding: 0px 0px 10px 0px;">{{nuevasTiendas.pais}}</p>

                <!-- <p style="font-size: 9px;"><img src="../../../../assets/images/Incoming-call.svg" style=" width: 14px; height: 14px;" alt=""> {{comercio.tlf}} </p>
                <p style="font-size: 8px;"><img src="../../../../assets/images/Mail.svg" style=" width: 14px; height: 14px;" alt=""> {{comercio.email}} </p> -->
            </div>
            <div class="card-footerI row" style="padding: 0% !important;">
                <div class="col-10" *ngIf="nuevasTiendas.servicios === 1" (click)="iraComercio(0)" style="margin: auto; border-top: 1px solid rgba(0,0,0,.125); padding: 4px 8px;">
                    RESERVAS
                </div>
                <div class="col-10" (click)="iraComercio(1)" style="margin: auto; border-top: 1px solid rgba(0,0,0,.125); padding: 4px 8px;">VER CATÁLOGO</div>
            </div>
        </div>
    </div>
    <div class="col-3" style="padding: 0px 10px;"></div>
</div>

<div *ngIf="!finalizar && !loading && !flagTx">
    <div class="animated fadeInUp">
        <div class="containerS">
            <input class="inputSerch" type="text" (change)="buscarProductos()" id="buscadorHtml" placeholder="buscar...">
            <div class="search"></div>
        </div>
        <nav class="nav" style=" overflow-x: scroll; overflow-y: hidden;" >
            <div class="row flex-row flex-nowrap mx-auto">
                <a *ngFor="let categoria of nuevasCategorias" (click)='cargaProductos(categoria.category_id)' class="nav-item">{{categoria.title}}</a>
                <span class="nav-indicator"></span>
            </div>
        </nav>
    </div>
    <!-- <div class="circulo-delivery" style="position: absolute;"><img class="circulob" src="../../../assets/images/delivery.png" alt="" (click)="openModal(contenido)" alt="..." data-toggle="modal" data-target="#staticBackdrop"></div> -->
    <app-products class="animated fadeInUp" (finalizarPedido)="cerrarCatalogo( $event )" *ngIf="!flagTx" [categoriaInput]="cateSelected" [idComercio]="idComercio" [etiquetasCom]="etiquetasCom" [ecomerce]="ecomerce" [nombre_tienda]="nuevasTiendas.ecommerce"></app-products>

</div>


<div *ngIf="finalizar" class="final animated fadeIn">
    <div class="card-columns">
        <div class="card-elm text-center" style="padding-top: 30pt !important;">
            <p>PEDIDO REGISTRADO CON ÉXITO</p>
        </div>
        <div class="card-elm">
            <img src="../../../assets/images/confirm.svg" style="height: 113px; width: 113px; align-self: center;" alt="...">
        </div>
        <div class="card-elm text-center">
            <blockquote class="blockquote mb-0">
                <small>*LA VENTANA SE CIERRA EN {{ totalTime }} SEGUNDOS</small>
            </blockquote>
        </div>
        <div class="card-elm">
            <button type="button" class="btn btn-otl-cerrar btn-block" (click)="cerrar()"><b>CERRAR</b></button>
        </div>

    </div>
</div>
